import { render, staticRenderFns } from "./PachincoRegister.vue?vue&type=template&id=0cea525d&"
import script from "./PachincoRegister.vue?vue&type=script&lang=ts&"
export * from "./PachincoRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports